import React, {
    useEffect,
    useState
} from 'react';
import {
    Navigate
} from 'react-router-dom';
import API_BASE_URL from '../../config/api';

const ProtectedRoute = ({
    children
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const checkAdmin = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/admin/me`,
                    {
                        method: 'GET',
                        credentials: 'include'
                    }
                );

                if (!response.ok) {
                    setIsAuthenticated(false);
                    return;
                }

                setIsAuthenticated(true);
            } catch (error) {
                console.error(
                    '관리자 인증 확인 오류:',
                    error
                );

                setIsAuthenticated(false);
            } finally {
                setIsLoading(false);
            }
        };

        checkAdmin();
    }, []);

    if (isLoading) {
        return (
            <div>
                관리자 정보를 확인하고 있습니다.
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <Navigate
                to="/admin"
                replace
            />
        );
    }

    return children;
};

export default ProtectedRoute;